import { useEffect, useState } from "react";

// The site sets no cookies and runs no analytics or ads, so there is nothing
// to accept or refuse: this only says so and links to the policy. If tracking
// is ever added, this has to become a real choice (Accept / Reject, nothing
// loaded before Accept) and /cookies has to list it.
const SEEN_KEY = "hethera.cookieNotice";

// Paystack sends people here mid-payment; they're on their way to WhatsApp.
const HIDDEN_ON = ["/payment-success"];

type Props = {
  path: string;
};

export function CookieNotice({ path }: Props) {
  // Never prerendered: whether it shows depends on this browser.
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let seen = false;
    try {
      seen = window.localStorage.getItem(SEEN_KEY) === "1";
    } catch {
      // Storage blocked: show it, and "Got it" hides it for this page view.
    }
    if (!seen) setOpen(true);
  }, []);

  if (!open || HIDDEN_ON.includes(path)) return null;

  const dismiss = () => {
    try {
      window.localStorage.setItem(SEEN_KEY, "1");
    } catch {
      // Nothing to remember it in; it'll show again next visit.
    }
    setOpen(false);
  };

  return (
    <section className="cookie-notice" aria-label="Cookies">
      <p>
        <strong>No tracking cookies here.</strong> We don't use cookies for ads
        or analytics. The site only keeps what it needs to work.{" "}
        <a href="/cookies">Cookie Policy</a>
      </p>
      <button type="button" className="btn btn-dark" onClick={dismiss}>
        Got it
      </button>
    </section>
  );
}
